// Aurum Brothers — custom JavaScript

// === Featured collections — sliding tab indicator (data-active) ===
(function () {
  function initFeaturedCollectionsNav() {
    document.querySelectorAll('.featured-collections-navigation').forEach(function (nav) {
      var buttons = Array.from(nav.querySelectorAll('button'));

      function setActive(index) {
        nav.setAttribute('data-active', index);
      }

      // Set initial state from aria-current
      var initial = buttons.findIndex(function (b) {
        return b.getAttribute('aria-current') === 'true';
      });
      setActive(initial >= 0 ? initial : 0);

      // Update on click
      buttons.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          setActive(index);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionsNav);
  } else {
    initFeaturedCollectionsNav();
  }
})();

// === Size limits tooltip — mobile click toggle (KAN-82) ===
var sizeLimitsReady = false;

function initSizeLimits() {
  document.querySelectorAll('.size-limits').forEach(function (widget) {
    var trigger = widget.querySelector('.size-limits__trigger');
    var closeBtn = widget.querySelector('.size-limits__close');

    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });

  if (!sizeLimitsReady) {
    sizeLimitsReady = true;
    document.addEventListener('click', function () {
      document.querySelectorAll('.size-limits__trigger[aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSizeLimits);
} else {
  initSizeLimits();
}

// === Homepage Hero Parallax (GSAP ScrollTrigger) ===
// Targets Prestige theme's slideshow section (.shopify-section--slideshow)
function initHeroParallax() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  // Prestige wraps the slideshow section in .shopify-section--slideshow
  var heroSection = document.querySelector('.shopify-section--slideshow');
  if (!heroSection) return;

  // First active slide — Prestige adds .is-selected on initialisation
  var firstSlide =
    heroSection.querySelector('.slideshow__slide.is-selected') || heroSection.querySelector('.slideshow__slide');
  if (!firstSlide) return;

  // Prestige slideshow renders the background image as a bare <picture> inside .content-over-media
  var heroImage = firstSlide.querySelector('picture');
  // Text overlay lives in .slideshow__slide-content
  var heroContent = firstSlide.querySelector('.slideshow__slide-content');

  // Pre-scale the picture so the edges never show while it moves
  if (heroImage) {
    gsap.set(heroImage, { scale: 1.15, transformOrigin: '50% 50%' });
    // Image drifts down (slower) → depth effect
    gsap.to(heroImage, {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: {
        trigger: heroSection,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5,
      },
    });
  }

  // Text drifts upward faster → reinforces the parallax separation
  if (heroContent) {
    gsap.to(heroContent, {
      yPercent: -15,
      ease: 'none',
      scrollTrigger: {
        trigger: heroSection,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5,
      },
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initHeroParallax();
});

// === Variant Thumb Switcher — product card swatch click ===

function variantThumb_readData(thumb, handle) {
  const thumbsWrapper = thumb.closest('.variant-thumbs');
  if (!thumbsWrapper) return null;

  const selectorHandle = window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"');
  const template = thumbsWrapper.querySelector('template[data-product-handle="' + selectorHandle + '"]');
  if (!template) return null;

  const script = template.content
    ? template.content.querySelector('script[type="application/json"]')
    : template.querySelector('script[type="application/json"]');
  if (!script) return null;

  try {
    return JSON.parse(script.textContent.trim());
  } catch (err) {
    console.error('Invalid template JSON', err);
    return null;
  }
}

function variantThumb_updateMedia(card, data) {
  const img = card.querySelector('.product-card__image--primary') || card.querySelector('.product-card__media img');
  if (!img || !data.image) return;
  const base = data.image.replace(/&width=\d+/, '');
  img.src = data.image;
  img.srcset = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800]
    .map(function (w) {
      return base + '&width=' + w + ' ' + w + 'w';
    })
    .join(', ');
}

function variantThumb_updateLinks(card, data) {
  const mediaLink = card.querySelector('.product-card__media');
  if (mediaLink) mediaLink.href = data.url;

  const titleEl = card.querySelector('.product-title');
  if (titleEl) {
    titleEl.textContent = data.title;
    titleEl.href = data.url;
  }
}

function variantThumb_updatePrice(card, data) {
  const oldPrice = card.querySelector('.price-list');
  if (!oldPrice || !data.price_html) return;
  const temp = document.createElement('div');
  temp.innerHTML = data.price_html;
  oldPrice.replaceWith(temp.firstElementChild);
}

function variantThumb_updateVariantId(card, handle, data) {
  const variantInput = card.querySelector('input[name="id"]');
  if (variantInput && data.variant_id) variantInput.value = data.variant_id;

  const quickBuyModal = card.querySelector('quick-buy-modal');
  if (quickBuyModal) quickBuyModal.setAttribute('handle', handle);
}

function variantThumb_updateActiveState(card, activeThumb) {
  card.querySelectorAll('.variant-thumb').forEach(function (el) {
    el.classList.remove('selected');
    const elImg = el.querySelector('img');
    if (elImg) elImg.style.borderBottom = 'none';
  });
  activeThumb.classList.add('selected');
  const thumbImg = activeThumb.querySelector('img');
  if (thumbImg) thumbImg.style.borderBottom = '3px solid white';
}

function variantThumb_updateRating(card, data) {
  card.querySelectorAll('.klaviyo-star-rating-widget').forEach(function (el) {
    el.style.display = String(el.dataset.id) === String(data.product_id) ? 'block' : 'none';
  });
}

function variantThumb_updateBadges(card, data) {
  const figure = card.querySelector('.product-card__figure');
  let badgeList = card.querySelector('badge-list');
  if (!badgeList && figure) {
    badgeList = document.createElement('badge-list');
    badgeList.className = 'badge-list badge-list--vertical';
    figure.prepend(badgeList);
  }
  if (!badgeList) return;

  badgeList.innerHTML = '';
  if (data.badge) {
    const badges = Array.isArray(data.badge) ? data.badge : [data.badge];
    badges.forEach(function (text) {
      if (!text || !text.trim()) return;
      const span = document.createElement('span');
      span.className = 'badge badge--custom';
      span.textContent = text;
      badgeList.appendChild(span);
    });
  }
  if (data.available === false) {
    const soldOut = document.createElement('sold-out-badge');
    soldOut.className = 'badge badge--sold-out';
    soldOut.textContent = 'Sold out';
    badgeList.appendChild(soldOut);
  }
  badgeList.hidden = badgeList.children.length === 0;
}

function variantThumb_updateQuickBuy(card, data) {
  const btn = card.querySelector('.product-card__quick-add-button');
  if (btn) btn.style.display = data.available === false ? 'none' : '';
}

document.addEventListener('click', function (e) {
  const thumb = e.target.closest('.variant-thumb');
  if (!thumb) return;

  const card = thumb.closest('.product-card');
  if (!card) return;

  const handle = thumb.dataset.variantHandle;
  if (!handle) return;

  const data = variantThumb_readData(thumb, handle);
  if (!data) return;

  variantThumb_updateMedia(card, data);
  variantThumb_updateLinks(card, data);
  variantThumb_updatePrice(card, data);
  variantThumb_updateVariantId(card, handle, data);
  variantThumb_updateActiveState(card, thumb);
  variantThumb_updateRating(card, data);
  variantThumb_updateBadges(card, data);
  variantThumb_updateQuickBuy(card, data);
});

// === Sticky ATC (scroll-back mode) — button handler ===
function skbSmoothScroll(targetY, duration) {
  var startY = window.pageYOffset;
  var diff = targetY - startY;
  var startTime = null;
  function step(ts) {
    if (!startTime) startTime = ts;
    var p = Math.min((ts - startTime) / duration, 1);
    var ease = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
    window.scrollTo(0, startY + diff * ease);
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-sticky-atc-trigger]');
  if (!btn) return;
  var formId = btn.dataset.stickyAtcTrigger;
  var f = document.getElementById('wrist-size');
  if (f && f.value.trim() === '') {
    var targetY = window.pageYOffset + f.getBoundingClientRect().top - window.innerHeight / 2 + f.offsetHeight / 2;
    skbSmoothScroll(targetY, 600);
    f.focus({ preventScroll: true });
  } else {
    document.querySelector('#' + formId + ' [type=submit]')?.click();
  }
});

// === Sticky ATC (scroll-back mode) — reliable scroll-based visibility ===
// The native IntersectionObserver in theme.js has edge cases with mobile virtual
// keyboards and smooth scrolling. We override visibility with a direct scroll check
// so the bar ALWAYS appears when the user is below the ATC form.
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('product-sticky-bar.product-sticky-bar--scroll-only');
  if (!bar) return;

  var formId = bar.getAttribute('form');
  var form = document.getElementById(formId) || document.forms[formId];
  if (!form) return;

  var footer = document.querySelector('.shopify-section--footer');

  function updateVisibility() {
    var formBottom = form.getBoundingClientRect().bottom;
    var belowForm = formBottom < 0;
    var beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;

    var shouldShow = belowForm && beforeFooter;
    bar.classList.toggle('is-visible', shouldShow);
    if (shouldShow) bar.removeAttribute('hidden');
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  // Also catch viewport changes from mobile keyboard
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateVisibility);
  }
  updateVisibility();
});

// === Klaviyo star-rating: show review count as "(N)" instead of "N reviews" ===
// The .klaviyo-star-rating-widget is hydrated client-side by Klaviyo's onsite.js
// (see snippets/product-info.liquid `when 'rating'`). It renders the count as
// "28 reviews"; we want just "(28)". Klaviyo's internal markup/class names are
// not guaranteed, so we match on text content rather than selectors, handle both
// the single-element ("28 reviews") and split-element ("28" + "reviews") cases,
// stay idempotent, and re-apply when Klaviyo re-renders.
(function () {
  var SINGLE_RE = /^\s*(\d[\d,]*)\s*reviews?\s*$/i; // "28 reviews" in one element
  var NUMBER_RE = /^\s*(\d[\d,]*)\s*$/; // "28" alone
  var WORD_RE = /reviews?/i;

  function leafElements(root) {
    return Array.prototype.filter.call(root.querySelectorAll('*'), function (el) {
      return el.children.length === 0 && el.textContent.trim() !== '';
    });
  }

  function formatWidget(widget) {
    var leaves = leafElements(widget);
    var i;

    // Case 1: number and word live in the same leaf ("28 reviews").
    for (i = 0; i < leaves.length; i++) {
      var m = leaves[i].textContent.match(SINGLE_RE);
      if (m) {
        var formatted = '(' + m[1] + ')';
        if (leaves[i].textContent.trim() !== formatted) leaves[i].textContent = formatted;
        return;
      }
    }

    // Case 2: split across two leaves — a number leaf and a "reviews" label leaf.
    var numberLeaf = null;
    var wordLeaf = null;
    for (i = 0; i < leaves.length; i++) {
      var txt = leaves[i].textContent;
      if (!numberLeaf && NUMBER_RE.test(txt)) numberLeaf = leaves[i];
      else if (!wordLeaf && WORD_RE.test(txt)) wordLeaf = leaves[i];
    }
    if (numberLeaf && wordLeaf) {
      var n = numberLeaf.textContent.match(NUMBER_RE)[1];
      var wrapped = '(' + n + ')';
      if (numberLeaf.textContent.trim() !== wrapped) numberLeaf.textContent = wrapped;
      if (wordLeaf.textContent !== '') wordLeaf.textContent = '';
    }
  }

  function scan() {
    document.querySelectorAll('.klaviyo-star-rating-widget').forEach(formatWidget);
  }

  function start() {
    scan();
    // Klaviyo hydrates asynchronously and may re-render; re-apply on DOM changes.
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// === Cart add-to-cart failure tracking → GTM dataLayer → GA4 ===
// Prestige dispatches a bubbling `cart:error` event from the <product-form>'s
// inner <form> when an add-to-cart request fails (out of stock, quantity limit,
// etc.). We forward it to GTM's dataLayer as `cart_add_error`.
// The cart-page quantity updater also emits `cart:error` (with detail.message),
// so we only handle events that originate from an add-to-cart <form>.
(function () {
  document.addEventListener('cart:error', function (event) {
    var form = event.target;

    // Only track add-to-cart failures, not cart quantity-update errors.
    var isAddForm = form && form.tagName === 'FORM' && /\/cart\/add/.test(form.action || '');
    if (!isAddForm) return;

    var detail = event.detail || {};
    var variantField = form.elements ? form.elements['id'] : null;
    var productField = form.elements ? form.elements['product-id'] : null;
    var card = form.closest ? form.closest('product-card') : null;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cart_add_error',
      error_message: detail.error || detail.message || 'unknown',
      variant_id: variantField && variantField.value ? variantField.value : 'unknown',
      product_id: productField && productField.value ? productField.value : 'unknown',
      product_handle: card && card.getAttribute('handle') ? card.getAttribute('handle') : 'unknown',
      page_url: window.location.href,
      page_path: window.location.pathname,
    });
  });
})();
